import Utils from './Utils';

let instance = null;

export class History {
  static singleton() {
    return instance;
  }

  constructor() {
    this.currentPopup = null;
    this.popups = {};

    window.addEventListener("popstate",(event) => {
      let hashArray = event.target.location.hash.substring(1).split('#');
      let hash = hashArray[hashArray.length-1];
      if (this.currentPopup && !this.existPopup(hash) && Utils.isObject(this.popups[this.currentPopup])) {
        this.popups[this.currentPopup].closeFn(false);
      }
    });
  }

  static init() {
    if (instance) {
      return;
    }
    instance = new History();
  }

  register = (name, openFn, closeFn) => {
    this.popups[name] = {
      openFn: openFn,
      closeFn: closeFn
    };
  };

  unregister = (name) => {
    delete this.popups[name];
    if (this.currentPopup === name){
      this.close(true);
    }
  };

  show = (name) => {
    this.currentPopup = name;
    let path = window.location.hash.split('#').join('');
    window.history.pushState({ popup: true }, name, "#" + path + "#" + name);
  };

  close = (back) => {
    this.currentPopup = null;
    if (back) {
      window.history.back();
    }
  };

  existPopup = (name) => {
    var exist = false;
    Object.keys(this.popups).forEach((key) => {
      if (key === name) {
        exist = true;
      }
    });
    return exist;
  };
}

export default History;
